import { VideoManager } from "@/components/admin/VideoManager";
import { InviteManager } from "@/components/admin/InviteManager";
import { ListingImageUpdater } from "@/components/admin/ListingImageUpdater";
import { CacheInvalidator } from "@/components/admin/CacheInvalidator";
import { ListingDeleter } from "@/components/admin/ListingDeleter";
import { ListingActivator } from "@/components/admin/ListingActivator";
import { AdminUserDeleteCard } from "@/components/admin/AdminUserDeleteCard";
import { PasswordResetCard } from "@/components/admin/PasswordResetCard";
import { VerificationEmailResend } from "@/components/admin/VerificationEmailResend";
import { UserList } from "@/components/admin/UserList";
import { QuickImageUpdater } from "@/components/admin/QuickImageUpdater";
import { AdminListingEditor } from "@/components/admin/AdminListingEditor";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function AdminSetup() {
  return (
    <div className="container mx-auto px-4 py-8">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold mb-4">Admin Setup</h1>
        <div className="mb-6">
          <Button asChild variant="secondary">
            <Link to="/admin-delete-user">Go to Delete User</Link>
          </Button>
        </div>
        <div className="grid gap-8">
          <AdminListingEditor />
          <QuickImageUpdater />
          <UserList />
          <ListingActivator />
          <AdminUserDeleteCard />
          <PasswordResetCard />
          <VerificationEmailResend />
          <ListingDeleter />
          <CacheInvalidator />
          <InviteManager />
          <VideoManager />
          <ListingImageUpdater />
        </div>
      </div>
    </div>
  );
}